import ReactDOMServer from "react-dom/server";

export default function reactToString(reactEl): string {
	return ReactDOMServer.renderToStaticMarkup(reactEl);
}
